import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Header from "../../components/header";
import { authenticatedFetch } from "../../../network/api";
import "./activateLawyer.css";

const LawyerActivationPage = () => {
  const navigate = useNavigate();
  const [acknowledged, setAcknowledged] = useState(false);
  const [activating, setActivating] = useState(false);
  const [error, setError] = useState(null);

  const user = useSelector((s) => s.attorneyData.attorneyData);

  const handleActivate = async () => {
    if (!user?.user_id) return;
    setActivating(true);
    setError(null);
    try {
      const res = await authenticatedFetch("/api/attorney/webapp/activateLawyer", {
        method: "POST",
        body: JSON.stringify({ user_id: user.user_id, acknowledge: acknowledged }),
      });
      const data = await res.json();
      if (!res.ok || data?.error) {
        throw new Error(data?.error || "Activation failed");
      }
      navigate("/onboarding/success-lawyer");
    } catch (e) {
      setError(e.message || "Activation failed. Please try again.");
    } finally {
      setActivating(false);
    }
  };

  const handleReviewProfile = () => {
    navigate("/attorney/settings");
  };

  const handleViewGuidelines = () => {
    navigate("/help/visibility");
  };

  const checklistItems = [
    { text: "Profile photo and bio completed", completed: true },
    { text: "Availability set and up to date", completed: true },
    { text: "Practice areas selected", completed: true },
  ];

  const faqItems = [
    {
      question: "What becomes publicly visible?",
      answer:
        "Your name, profile photo, practice areas, experience, languages, and availability summary may be visible to potential clients.",
    },
    {
      question: "Can I deactivate my profile later?",
      answer:
        "Yes. You can change your visibility at any time from your settings. Changes take effect immediately.",
    },
  ];

  return (
    <div className="firm-activation-container">
      <Header />

      <main className="firm-activation-main" role="main">
        <section className="hero-section-activate">
          <div className="eyebrow">Final Step</div>
          <h1 className="hero-title-activate">Activate your Quidpro profile</h1>
          <p className="hero-subtitle-activate">
            Make your profile visible on the marketplace so new clients can find and book you.
          </p>
        </section>

        <section className="card-activate centered-card">
          <h2 className="section-title">Pre-activation Checklist</h2>
          <ul className="checklist">
            {checklistItems.map((item, index) => (
              <li key={index} className={`checklist-item ${item.completed ? "auto" : "manual"}`}>
                {item.text}
              </li>
            ))}
          </ul>
          <button className="link-button" onClick={handleReviewProfile} type="button">
            Review your profile →
          </button>
        </section>

        <section className="card-activate preview-card">
          <h2 className="section-title">Marketplace Preview</h2>
          <div className="preview-placeholder">Your profile preview will appear here</div>
        </section>

        <section className="card-activate callout-card">
          <div className="callout-header">
            <div className="callout-icon">🚀</div>
            <div>
              <h3 className="callout-title">Ready to Activate</h3>
              <p className="callout-body">
                Your profile will be visible in search results immediately upon activation.
              </p>
            </div>
          </div>

          <label className="toggle-row">
            <input
              type="checkbox"
              checked={acknowledged}
              onChange={(e) => setAcknowledged(e.target.checked)}
              disabled={activating}
            />
            <span>I agree to the visibility guidelines</span>
          </label>

          <div className="actions">
            <button
              className="primary-button"
              onClick={handleActivate}
              disabled={activating || !user?.user_id}
              type="button"
            >
              {activating ? "Activating..." : "Activate Profile"}
            </button>
            <button className="link-button" onClick={handleViewGuidelines} type="button" disabled={activating}>
              View visibility guidelines
            </button>
          </div>

          {error && (
            <div className="error-text" role="alert">
              {error}
            </div>
          )}
        </section>

        <section className="card-activate faq-card">
          <h2 className="section-title">Frequently Asked Questions</h2>
          {faqItems.map((item, index) => (
            <details key={index}>
              <summary>{item.question}</summary>
              <p>{item.answer}</p>
            </details>
          ))}
        </section>
      </main>
    </div>
  );
};

export default LawyerActivationPage;


